import Marquee from "react-fast-marquee";

const WORDS = ["We build brands", "We shift culture", "We make noise", "We earn attention"];

export default function EditorialMarquee() {
    return (
        <div data-testid="editorial-marquee" className="border-y border-line py-6 md:py-8 overflow-hidden">
            <Marquee speed={28} gradient={false} direction="left" pauseOnHover={true}>
                {WORDS.map((w, i) => (
                    <span key={i} className="flex items-center">
                        <span
                            className={`font-display italic font-light text-4xl md:text-6xl whitespace-nowrap px-6 ${
                                i % 2 === 0 ? "text-paper" : "text-outline"
                            }`}
                        >
                            {w}
                        </span>
                        <span className="font-display text-3xl md:text-5xl text-vermilion" aria-hidden="true">
                            ✱
                        </span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
